import React from "react";

const Icons = {
  CheckGreenIcon: () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32.5" cy="32.6697" r="32" fill="#35AE45" />
      <path
        d="M14.5 33.8617L25.7053 45.067L50.5 20.2723"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  ),
};

export default Icons;
